const YouTubeGetID = (url) => {
  if (typeof url !== 'string') {
    console.error('Invalid URL type. Expected a string:', url);
    return null;
  }

  // RegEx to match various YouTube video URL formats
  const regex =
    /(?:youtube\.com\/(?:embed\/([\w\-]{11})|watch\?v=([\w\-]{11})|.+\/(?:v|e(?:mbed)?)\/([\w\-]{11}))|youtu\.be\/([\w\-]{11}))/;
  const match = url.match(regex);

  if (match) {
    // Extract the video ID from matched groups
    return match[1] || match[2] || match[3] || match[4];
  } else {
    // Log the expected error message
    console.error('No video ID found in the URL', url);
    return null;
  }
};

export default YouTubeGetID;
